import { createAction, props } from '@ngrx/store';
import { PostVerifyAction } from 'src/app/pages/recover/recover.actions';
import { ApiRequestType } from 'src/app/shared/enums/api.enums';
import { Dictionary } from 'src/app/shared/types/dictionary';

export interface CustomData {
	disableRouting?: boolean;
	disableLoginCall?: boolean;
	postVerifyAction?: PostVerifyAction;
	threeDSParams?: Dictionary<any>;
	suppressModal?: boolean;
	updateURL?: boolean;
	isDeleteSecondary?: boolean;
	[key: string]: any;
}

/**
 * Sends a GET request
 */
export const getApiRequest = createAction(
	'[Api] GET Request',
	props<{ requestType: string; params?: Dictionary<any>; useGlobal?: boolean }>()
);

/**
 * Sends a POST request
 */
export const postApiRequest = createAction(
	'[Api] POST Request',
	props<{
		requestType: ApiRequestType;
		params?: Dictionary<any>;
		useGlobal?: boolean;
		redirectTo?: string[];
		customData?: CustomData;
	}>()
);

/**
 * The action for when a response comes back
 */
export const apiResponse = createAction(
	'[Api] Response',
	props<{
		isOk: boolean;
		status: string;
		requestType: ApiRequestType;
		response: any;
		params: Dictionary<any>;
		customData?: CustomData;
	}>()
);
